import styled from 'styled-components'

const ToggleButton = ({ value, onChange, title }) => {
    return (
        <StyledButton isSelected={value} onClick={onChange}>
            {title}
        </StyledButton>
    )
}

export default ToggleButton

const StyledButton = styled.button`
    font-weight: 600;
    cursor: pointer;
    text-transform: none;
    color: ${({ isSelected }) => (isSelected ? 'white' : 'black')};
    border: ${({ isSelected }) => (isSelected ? '1px solid #607afc' : '1px solid rgba(0, 0, 0, 0.2)')}; ;
    height: 32px;
    background-color: ${({ isSelected }) => (isSelected ? '#607afc' : 'white')};
    padding: 0 12px;
    border-radius: 10px;
    transition: all 0.2s ease-in-out;
    box-shadow:${({ isSelected }) => (isSelected ? '#637df4 1px 0.196px 11px' : 'none')};
`

